import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('OlisSetting-index-1992f2b89d11e5dec-1'),
    routerUrl: '/OlisSetting',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./OlisSetting')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('OlisSetting-index-1992f2b89d11e5dec-2'),
        routerUrl: '/OlisSettingForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./OlisSettingForm')),
      },
      //$MORE$
    ],
  },
];
